import { defineMessages } from 'react-intl';

/** The words of the block forms (design d0–d9). */
export const formMessages = defineMessages({
  saving: { id: 'app.sml.smartlinks.editor.form.saving', defaultMessage: 'Saving' },
  savedNotLive: { id: 'app.sml.smartlinks.editor.form.saved_not_live', defaultMessage: 'Saved · not live yet' },
  savedLive: { id: 'app.sml.smartlinks.editor.form.saved_live', defaultMessage: 'Saved and live' },
  notSaved: { id: 'app.sml.smartlinks.editor.form.not_saved', defaultMessage: 'Not saved. Check the field.' },
  notSavedAddress: {
    id: 'app.sml.smartlinks.editor.form.not_saved_address',
    defaultMessage: 'Not saved. Check the address.',
  },
  saveFailed: { id: 'app.sml.smartlinks.editor.form.save_failed', defaultMessage: 'Not saved. Try again.' },
  delete: { id: 'app.sml.smartlinks.editor.form.delete', defaultMessage: 'Delete' },
  done: { id: 'app.sml.smartlinks.editor.form.done', defaultMessage: 'Done' },
  optional: { id: 'app.sml.smartlinks.editor.form.optional', defaultMessage: 'optional' },
  // Text (d0, d1)
  style: { id: 'app.sml.smartlinks.editor.form.text.style', defaultMessage: 'Style' },
  text: { id: 'app.sml.smartlinks.editor.form.text.text', defaultMessage: 'Text' },
  textHelpTitle: {
    id: 'app.sml.smartlinks.editor.form.text.help_title',
    defaultMessage: 'Fans see it as a big line, centred.',
  },
  textHelpNormal: {
    id: 'app.sml.smartlinks.editor.form.text.help_normal',
    defaultMessage: 'Fans see it as a paragraph.',
  },
  textHelpSmall: {
    id: 'app.sml.smartlinks.editor.form.text.help_small',
    defaultMessage: 'Fans see it as small print, for credits or a note.',
  },
  textEmpty: { id: 'app.sml.smartlinks.editor.form.text.empty', defaultMessage: 'Write the text fans see.' },
  textTooLong: {
    id: 'app.sml.smartlinks.editor.form.text.too_long',
    defaultMessage: 'The text is too long. Keep it under {max} characters.',
  },
  // Link (d2, d3)
  opens: { id: 'app.sml.smartlinks.editor.form.link.opens', defaultMessage: 'Opens' },
  opensAddress: { id: 'app.sml.smartlinks.editor.form.link.opens_address', defaultMessage: 'A web address' },
  opensPage: { id: 'app.sml.smartlinks.editor.form.link.opens_page', defaultMessage: 'One of my pages' },
  address: { id: 'app.sml.smartlinks.editor.form.link.address', defaultMessage: 'Address' },
  addressBad: {
    id: 'app.sml.smartlinks.editor.form.link.address_bad',
    defaultMessage: 'This is not a web address. Paste the full address, for example https://laziibee.com/tickets.',
  },
  page: { id: 'app.sml.smartlinks.editor.form.link.page', defaultMessage: 'Page' },
  pageHelp: {
    id: 'app.sml.smartlinks.editor.form.link.page_help',
    defaultMessage: 'The link follows the page, also when you change its address.',
  },
  pageDraft: {
    id: 'app.sml.smartlinks.editor.form.link.page_draft',
    defaultMessage: 'Draft: fans see it after you publish it',
  },
  noOtherPages: {
    id: 'app.sml.smartlinks.editor.form.link.no_pages',
    defaultMessage: 'You have no other page yet.',
  },
  pagePick: { id: 'app.sml.smartlinks.editor.form.link.page_pick', defaultMessage: 'Pick a page' },
  buttonText: { id: 'app.sml.smartlinks.editor.form.link.button_text', defaultMessage: 'Button text' },
  buttonTextHelp: {
    id: 'app.sml.smartlinks.editor.form.link.button_text_help',
    defaultMessage: 'With no text, the button shows the address.',
  },
  // Player (d4)
  playerSong: { id: 'app.sml.smartlinks.editor.form.player.song', defaultMessage: 'Song to play' },
  playerFromCatalog: {
    id: 'app.sml.smartlinks.editor.form.player.from_catalog',
    defaultMessage: 'Use the Spotify link of a song in your Catalog',
  },
  playerPaste: {
    id: 'app.sml.smartlinks.editor.form.player.paste',
    defaultMessage: 'Or paste a link from Spotify, Apple Music, Deezer, SoundCloud or YouTube.',
  },
  playerLink: { id: 'app.sml.smartlinks.editor.form.player.link', defaultMessage: 'Link' },
  playerBad: {
    id: 'app.sml.smartlinks.editor.form.player.bad',
    defaultMessage: 'We cannot play this link. Paste a link from one of the services below.',
  },
  playerChooseSong: { id: 'app.sml.smartlinks.editor.form.player.choose_song', defaultMessage: 'Pick a song' },
  size: { id: 'app.sml.smartlinks.editor.form.player.size', defaultMessage: 'Size' },
  sizeHelp: {
    id: 'app.sml.smartlinks.editor.form.player.size_help',
    defaultMessage: 'Compact shows one line with the play button. Normal shows the cover and the track list.',
  },
  // Social links (d6)
  socialProfiles: { id: 'app.sml.smartlinks.editor.form.social.profiles', defaultMessage: 'Profiles on the page' },
  socialFromChannel: {
    id: 'app.sml.smartlinks.editor.form.social.from_channel',
    defaultMessage: 'from Promote channels',
  },
  socialFromConnection: {
    id: 'app.sml.smartlinks.editor.form.social.from_connection',
    defaultMessage: 'from Catalog connections',
  },
  socialNewProfiles: {
    id: 'app.sml.smartlinks.editor.form.social.new_profiles',
    defaultMessage: 'New profiles you connect show here by themselves.',
  },
  socialShow: { id: 'app.sml.smartlinks.editor.form.social.show', defaultMessage: 'Show {name} on the page' },
  // Profile (d7)
  profileNote: {
    id: 'app.sml.smartlinks.editor.form.profile.note',
    defaultMessage: 'This block shows your artist photo, name and bio. One place to change them for every page.',
  },
  // Image (d9)
  imageNote: {
    id: 'app.sml.smartlinks.editor.form.image.note',
    defaultMessage:
      'Turn it into a Media block. Same picture, plus a caption, a tap link and the shape. Fans see no change until you edit it.',
  },
  imageTurn: { id: 'app.sml.smartlinks.editor.form.image.turn', defaultMessage: 'Turn into Media' },
  imageNoFile: {
    id: 'app.sml.smartlinks.editor.form.image.no_file',
    defaultMessage: 'The picture of this block is gone. Delete the block, or add a Media block.',
  },
  // Get every release (d8)
  subscribeNoService: {
    id: 'app.sml.smartlinks.editor.form.subscribe.no_service',
    defaultMessage: 'Pick at least one service. Not saved.',
  },
});
